import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const AnalyticsApi = {
    getWebRtcStatistics: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['analytics', 'getWebRtcStatistics', webinarId], (api) => api.analytics.getWebRtcStatistics(webinarId), options)
};
